// Pure counter: N taps within a window. Returns a function you call per tap; it returns true on the Nth.
export function createTapCounter({ taps = 5, windowMs = 3000, now = () => Date.now() } = {}) {
  let times = [];
  return function tap() {
    const t = now();
    times = times.filter(x => t - x <= windowMs);
    times.push(t);
    if (times.length >= taps) { times = []; return true; }
    return false;
  };
}
